import {Group, Text, UnstyledButton} from '@mantine/core';
import type {FC} from 'react';

/**
 * Paired "Enable All" / "Disable All" text links, separated by a pipe.
 * @registry Enable-all / disable-all link pair for bulk toggling a list.
 *
 * Ported from `library-m/components/buttons/BulkToggleLinks`. Prop surface
 * kept identical.
 */
export interface BulkToggleLinksProps {
  onEnableAll: () => void;
  onDisableAll: () => void;
  size?: 'xs' | 'sm';
  testIdPrefix?: string;
}

export const BulkToggleLinks: FC<BulkToggleLinksProps> = ({
  onEnableAll,
  onDisableAll,
  size = 'sm',
  testIdPrefix,
}) => {
  return (
    <Group gap={4}>
      <UnstyledButton
        onClick={onEnableAll}
        data-testid={testIdPrefix ? `${testIdPrefix}-enable-all` : undefined}>
        <Text size={size} c="blue" td="hover:underline">
          Enable All
        </Text>
      </UnstyledButton>
      <Text size={size} c="dimmed">
        |
      </Text>
      <UnstyledButton
        onClick={onDisableAll}
        data-testid={testIdPrefix ? `${testIdPrefix}-disable-all` : undefined}>
        <Text size={size} c="red" td="hover:underline">
          Disable All
        </Text>
      </UnstyledButton>
    </Group>
  );
};
